import { useDispatch, useSelector } from "react-redux";
import AllDropDownsAHSF from "../../../Components/AllDropDownsAHSF";
import SharedDiv from "../../../Components/SharedDiv/SharedDiv";
import TextAreaAHSF from "../../../Components/TextAreaAHSF";
import ProjectInformationPage from "../../../Containers/ProjectInformationPage";
import { useEffect, useState } from "react";
import {
  GetProjectPlanDetails,
  SetProjectPlanDetails,
  ValidateProjectPlanDetails,
} from "../../../Redux/Reducers/ProjectInformationPage/ProjectPlanDetails";
import LoaderAHSF from "../../../Components/LoaderAHSF";
import UpdateProjectPlan from "../../../Services/ProjectInformationPage/ProjectPlanDetails/UpdateProjectPlan";
import ButtonAHSF from "../../../Components/ButtonAHSF";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import loadConfig from "../../../Services/apiService";
import PopupAHSF from "../../../Components/PopupAHSF";
import { useParams } from "react-router-dom";
import { decryptToken } from "../../../Services/Account/EncryptionParams";

const ProjectWorkPlanModule = () => {
  const AppGuid = useParams();
  const dispatch = useDispatch();
  const state = useSelector((state) => {
    return {
      ProjectPlanDetails: state.ProjectPlanDetails.ProjectPlanDetails,
      ApplicationInformation:
        state.ApplicationInformation.ApplicationInformation,
      loadingGetProjectPlanDetails:
        state.ProjectPlanDetails.loadingGetProjectPlanDetails,
      ProjectPlanDetailsValidate:
        state.ProjectPlanDetails.ProjectPlanDetailsValidate,
      ActiveRound: state.ApplicationInformation.ActiveRound,
    };
  });
  const ProjectPlanDetails = useSelector(
    (state) => state.ProjectPlanDetails.ProjectPlanDetails
  );
  const YesOrNO = [
    { KeyText: "نعم", KeyValue: true },
    { KeyText: "لا", KeyValue: false },
  ];
  const navigate = useNavigate();
  // State for holding project details
  const [projectDetails, setProjectDetails] = useState({
    // mainActivitiesProjectImplementation:
    //   state.ProjectPlanDetails?.mainActivitiesProjectImplementation,
    // projectPhases: state.ProjectPlanDetails?.projectPhases,
    // approvalsForSchoolProjects:
    //   state.ProjectPlanDetails?.approvalsForSchoolProjects,
    // plannedElectronicContentInfo:
    //   state.ProjectPlanDetails?.plannedElectronicContentInfo,
    // uniqueProjectValue: state.ProjectPlanDetails?.uniqueProjectValue,
    // activitiesInSchools: state.ProjectPlanDetails?.activitiesInSchools,
    // educationalContentCreation:
    //   state.ProjectPlanDetails?.educationalContentCreation,

    ...state.ProjectPlanDetails,
  });
  const [dataJsonObject, SetDataJsonObject] = useState();
  const [isPopupOpenStatus, setisPopupOpenStatus] = useState(false);
  const dataJson = async () => {
    let jsonData = await loadConfig();
    SetDataJsonObject(jsonData);
    //console.log(jsonData, "jsonData");
  };

  //console.log(state.ProjectPlanDetails, "ProjectPlanDetails");
//get data once for project plan by id
  useEffect(() => {
    // Fetch project plan details when component mounts
    dispatch(
      GetProjectPlanDetails(
        state.ApplicationInformation.aI_ApplicationInformationId ||
          decryptToken(AppGuid.AppGuid)
      )
    );
  }, []);

  // Save project plan details using the service

//update data and if validate move to next page

  const SaveDataPage = async (withValidate) => {
    const saved = await UpdateProjectPlan(
      state.ProjectPlanDetails?.pS_ProjectSummaryId,
      projectDetails.mainActivitiesProjectImplementation,
      projectDetails.projectPhases,
      projectDetails.activitiesInSchools,
      projectDetails.educationalContentCreation,
      projectDetails.approvalsForSchoolProjects,
      projectDetails.plannedElectronicContentInfo,
      projectDetails.uniqueProjectValue,
      projectDetails.aI_ApplicationInformationId
    );
    // Validate the project plan after saving
    if (withValidate == true && saved) {
      const validate = await dispatch(
        ValidateProjectPlanDetails(
          state.ProjectPlanDetails.aI_ApplicationInformationId
        )
      );
      //after validate ends save data then move to next page
      if (validate.payload.length === 0) {
        Swal.fire({
          position: "center",
          icon: "success",
          title: "تم حفظ المعلومات بنجاح",
          showConfirmButton: false,
          timer: 1500,
          // width: "500px",
        });
        navigate("/grants/InformationProject/ImpactSustainability");
      } else {
        setisPopupOpenStatus(true);
      }
    }
  };
  //console.log(
  //   state.ApplicationInformation.aI_ApplicationInformationId,
  //   "fffffffffffffffffffffffffffff"
  // );

  useEffect(() => {
    // Update state with fetched project details
    if (!state.loadingGetProjectPlanDetails) {
      //console.log(state.ProjectPlanDetails, "oppopoopopopokkkkkkkkk");

      setProjectDetails({ ...state.ProjectPlanDetails });
    }
  }, [state.loadingGetProjectPlanDetails]);

  useEffect(() => {
    dispatch(SetProjectPlanDetails({ ...projectDetails }));
  }, [projectDetails]);

  //console.log(ProjectPlanDetails, "projectDetalis");

  const shouldDisableFields =!(
   //[,]
// مابقدر يعدل اذا ماكانت الدورة فعالة او managerالحالة قيد المراجة او الدخول من ال
state.ActiveRound ==
      state.ApplicationInformation?.aI_RoundYearId &&
    state.ApplicationInformation?.aI_ApplicationStatus?.canEdite &&
    window.location.href.includes("manager") == false);


  // useEffect(() => {
  //   if (
  //     state.ProjectPlanDetails?.activitiesInSchools == "false" ||
  //     state.ProjectPlanDetails?.activitiesInSchools == false
  //   ) {
  //     setProjectDetails((prev) => ({
  //       ...prev,
  //       approvalsForSchoolProjects: null,
  //     }));
  //   }
  // }, [state.ProjectPlanDetails?.activitiesInSchools]);

  // useEffect(() => {
  //   if (
  //     state.ProjectPlanDetails?.educationalContentCreation == "false" ||
  //     state.ProjectPlanDetails?.educationalContentCreation == false
  //   ) {
  //     setProjectDetails((prev) => ({
  //       ...prev,
  //       plannedElectronicContentInfo: null,
  //     }));
  //   }
  // }, [state.ProjectPlanDetails?.educationalContentCreation]);

  useEffect(() => {
    // Check specific conditions to set approval fields to null if not required

    const { activitiesInSchools, educationalContentCreation } =
      state.ProjectPlanDetails || {};

    setProjectDetails((prev) => ({
      ...prev,
      approvalsForSchoolProjects:
        activitiesInSchools === "false" || activitiesInSchools === false
          ? null
          : prev.approvalsForSchoolProjects, // Set approvals field to null if school projects aren't selected
      plannedElectronicContentInfo:
        educationalContentCreation === "false" ||
        educationalContentCreation === false
          ? null
          : prev.plannedElectronicContentInfo, // Set content info field to null if educational content isn't selected
    }));
  }, [
    state.ProjectPlanDetails?.activitiesInSchools,
    state.ProjectPlanDetails?.educationalContentCreation,
  ]);
//after loading ends render html
  return (
    <>
      <ProjectInformationPage active={2} />
      {!state.loadingGetProjectPlanDetails ? (
        <>
          <SharedDiv
            showTitle={true}
            titleName="تفاصيل خطة عمل المشروع"
            child={[
              <div className="form-grid">
                <TextAreaAHSF
                  fieldsName="MainActivities"
                  show={true}
                  disabled={shouldDisableFields}
                  defaultValue={
                    state.ProjectPlanDetails
                      ?.mainActivitiesProjectImplementation
                  }
                  onChange={(e) => {
                    setProjectDetails({
                      ...projectDetails,
                      mainActivitiesProjectImplementation: e.target.value, // التحديث هنا
                    });
                  }}
                  showValidationMessage={
                    state.ProjectPlanDetailsValidate
                      ? state.ProjectPlanDetailsValidate.includes(
                          "MainActivities"
                        )
                      : false
                  }
                  validationMessage="يرجى تعبئة هذا الحقل"
                />
                <TextAreaAHSF
                  fieldsName="ProjStages"
                  show={true}
                  disabled={shouldDisableFields}
                  defaultValue={state.ProjectPlanDetails?.projectPhases}
                  onChange={(e) => {
                    setProjectDetails({
                      ...projectDetails,
                      projectPhases: e.target.value, // التحديث هنا
                    });
                  }}
                  showValidationMessage={
                    state.ProjectPlanDetailsValidate
                      ? state.ProjectPlanDetailsValidate.includes("ProjStages")
                      : false
                  }
                  validationMessage="يرجى تعبئة هذا الحقل"
                />
                <AllDropDownsAHSF
                  fieldsName="ClassroomActivities"
                  show={true}
                  disabled={shouldDisableFields}
                  dropdownType={"normal"}
                  KeyText={"KeyText"}
                  KeyValue={"KeyValue"}
                  arrayOoptionList={YesOrNO}
                  value={state.ProjectPlanDetails?.activitiesInSchools}
                  onChange={(e) => {
                    setProjectDetails({
                      ...projectDetails,
                      activitiesInSchools: JSON.parse(e.target.value), // التحديث هنا
                    });
                  }}
                  showValidationMessage={
                    state.ProjectPlanDetailsValidate
                      ? state.ProjectPlanDetailsValidate.includes(
                          "ClassroomActivities"
                        )
                      : false
                  }
                  validationMessage="يرجى تعبئة هذا الحقل"
                />
                {state.ProjectPlanDetails?.activitiesInSchools == "true" ||
                state.ProjectPlanDetails?.activitiesInSchools == true ? (
                  <>
                    <TextAreaAHSF
                      fieldsName="ProjectApprovals"
                      show={true}
                      disabled={shouldDisableFields}
                      defaultValue={
                        state.ProjectPlanDetails?.approvalsForSchoolProjects
                      }
                      onChange={(e) => {
                        setProjectDetails({
                          ...projectDetails,
                          approvalsForSchoolProjects: e.target.value,
                        });
                      }}
                      showValidationMessage={
                        state.ProjectPlanDetailsValidate
                          ? state.ProjectPlanDetailsValidate.includes(
                              "ProjectApprovals"
                            )
                          : false
                      }
                      validationMessage="يرجى تعبئة هذا الحقل"
                    />
                  </>
                ) : (
                  ""
                )}
                <AllDropDownsAHSF
                  fieldsName="EContentPlan"
                  show={true}
                  disabled={shouldDisableFields}
                  dropdownType={"normal"}
                  KeyText={"KeyText"}
                  KeyValue={"KeyValue"}
                  arrayOoptionList={YesOrNO}
                  value={state.ProjectPlanDetails?.educationalContentCreation}
                  onChange={(e) => {
                    setProjectDetails({
                      ...projectDetails,
                      educationalContentCreation: JSON.parse(e.target.value),
                    });
                  }}
                  showValidationMessage={
                    state.ProjectPlanDetailsValidate
                      ? state.ProjectPlanDetailsValidate.includes(
                          "EContentPlan"
                        )
                      : false
                  }
                  validationMessage="يرجى تعبئة هذا الحقل"
                />
                {state.ProjectPlanDetails?.educationalContentCreation ==
                  "true" ||
                state.ProjectPlanDetails?.educationalContentCreation == true ? (
                  <>
                    <TextAreaAHSF
                      fieldsName="PlannedEContentInfo"
                      show={true}
                      disabled={shouldDisableFields}
                      defaultValue={
                        state.ProjectPlanDetails?.plannedElectronicContentInfo
                      }
                      onChange={(e) => {
                        setProjectDetails({
                          ...projectDetails,
                          plannedElectronicContentInfo: e.target.value,
                        });
                      }}
                      showValidationMessage={
                        state.ProjectPlanDetailsValidate
                          ? state.ProjectPlanDetailsValidate.includes(
                              "PlannedEContentInfo"
                            )
                          : false
                      }
                      validationMessage="يرجى تعبئة هذا الحقل"
                    />
                  </>
                ) : (
                  ""
                )}
                <TextAreaAHSF
                  fieldsName="ProjectValueProp"
                  show={true}
                  disabled={shouldDisableFields}
                  defaultValue={state.ProjectPlanDetails?.uniqueProjectValue}
                  onChange={(e) => {
                    setProjectDetails({
                      ...projectDetails,
                      uniqueProjectValue: e.target.value,
                    });
                  }}
                  showValidationMessage={
                    state.ProjectPlanDetailsValidate
                      ? state.ProjectPlanDetailsValidate.includes(
                          "ProjectValueProp"
                        )
                      : false
                  }
                  validationMessage="يرجى تعبئة هذا الحقل"
                />
              </div>,
            ]}
          />
          {!shouldDisableFields ? (
            <div className="containerButtonMAin">
              <ButtonAHSF
                type={"submitter"}
                onClick={() => {
                  Swal.fire({
                    position: "center",
                    icon: "success",
                    title: "تم حفظ المعلومات بنجاح",
                    showConfirmButton: false,
                    timer: 1500,
                    // width: "500px",
                  });
                  SaveDataPage(false);
                }}
                disabled={false}
                title={"حفظ"}
                text={"حفظ"}
                show={true}
              />
              <ButtonAHSF
                type={"submitter"}
                onClick={() => {
                  SaveDataPage(true);
                }}
                disabled={false}
                title={"التالي"}
                text={"التالي"}
                show={true}
              />
            </div>
          ) : (
            ""
          )}
        </>
      ) : (
        ""
      )}
      <LoaderAHSF show={state.loadingGetProjectPlanDetails} />
      <PopupAHSF
        isPopupOpenStatus={isPopupOpenStatus}
        isPopupOpenFunction={() => setisPopupOpenStatus(false)}
        forValidate={true}
        maxWidth="50%"
        title="يرجى تعبئة الحقول المطلوبة"
        componentBody={state.ProjectPlanDetailsValidate}
      />
    </>
  );
};

export default ProjectWorkPlanModule;
